import { render, staticRenderFns } from "./SearchPrompt.vue?vue&type=template&id=047f0876&"
import script from "./SearchPrompt.vue?vue&type=script&lang=js&"
export * from "./SearchPrompt.vue?vue&type=script&lang=js&"
import style0 from "./SearchPrompt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports